import { render, staticRenderFns } from "./MemberStatuses.vue?vue&type=template&id=58d24296"
import script from "./MemberStatuses.vue?vue&type=script&lang=ts"
export * from "./MemberStatuses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports